export default "../../src/img/bullet.svg";